import { useField } from "formik";
import ToggleSwitch from "./ToggleSwitch";

export default function ToggleSwitchFormik({
  className,
  disabled,
  name,
  value,
}) {
  const [{ checked, onChange }] = useField({
    name,
    value,
    type: "checkbox",
  });

  return (
    <ToggleSwitch
      name={name}
      value={value}
      status={checked}
      onToggle={onChange}
      hasApiCall={false}
      disabled={disabled}
      className={className}
    />
  );
}
